import { useRef } from "react";
import { noop, stubFalse } from "lodash/fp";
import { useEventListener } from "./use-event-listener.es.js";
import { useHandler } from "./use-handler.es.js";
import { getRootNode } from "../utils/get-root-node.es.js";
function useKeyboardShortcut(options = {}) {
  const { callback = noop, predicate = stubFalse } = options;
  const ref = useRef();
  useEventListener(
    "keydown",
    useHandler((event) => {
      if (predicate(event) && (event.target === document.body || getRootNode(event.target) === getRootNode(ref.current))) {
        callback(event);
      }
    })
  );
  return ref;
}
export {
  useKeyboardShortcut
};
